import React, { useEffect } from 'react'
import { MdBookmark, MdDelete, MdBookmarkBorder } from 'react-icons/md'
import { useDispatch, useSelector } from 'react-redux'
import history from '../../../lib/history'
import routes from '../../../config/routes'
import * as reducks from '../../../reducks'
import Flex from '../../commons/Flex/Flex'
import Text from '../../commons/Text/Text'
import Tag from '../../commons/Tag/Tag'
import DefaultLayout from '../../commons/Layouts/DefaultLayout'
import Button from '../../commons/Button/Button'
import CardHighlight from '../../commons/CardHighlight/CardHighlight'
import Card from '../../commons/Card/Card'
import Thumbnail from '../../commons/Thumbnail/Thumbnail'
import Box from '../../commons/Icons/Box'
import Chat from '../../commons/Icons/Chat'
import Process from '../../commons/Icons/Process'
import MegaPhone from '../../commons/Icons/MegaPhone'
import WorkTool from '../../commons/Icons/WorkTool'
import Comission from '../../commons/Icons/Comission'
import PricingProcess from '../../commons/Icons/PricingProcess'
import Training from '../../commons/Icons/Training'
import LoadingBounce from '../../commons/LoadingBounce/LoadingBounce'
import BoyNoContent from '../../commons/Ilustrations/BoyNoContent'
import styles from './contentContainer.module.scss'

const Content = () => {
  const dispatch = useDispatch()

  const knowledgeBaseReducer = useSelector(
    (store) => store.knowledgeBaseReducer
  )

  const redirectToDetail = (item) => {
    history.push(routes.contentDetail.path.replace(':contentId', item.id))
  }

  const applyFilter = (category) => {
    dispatch(
      reducks.resources.knowledgeBase.actions.setFilters({
        categoryId: category.id
      })
    )
    dispatch(reducks.resources.knowledgeBase.actions.getHighlights())
    dispatch(reducks.resources.knowledgeBase.actions.getRecents())
  }

  const clearFilters = () => {
    dispatch(
      reducks.resources.knowledgeBase.actions.setFilters({
        categoryId: null
      })
    )
    setTimeout(() => {
      dispatch(reducks.resources.knowledgeBase.actions.getHighlights())
      dispatch(reducks.resources.knowledgeBase.actions.getRecents())
    }, 500)
  }

  useEffect(() => {
    dispatch(
      reducks.resources.knowledgeBase.actions.setFilters({
        categoryId: null
      })
    )
    dispatch(reducks.resources.knowledgeBase.actions.getCategories())
    dispatch(reducks.resources.knowledgeBase.actions.getHighlights())
    dispatch(reducks.resources.knowledgeBase.actions.getRecents())
  }, [])

  const renderIconPerType = (icon) => {
    switch (icon) {
      case 2:
        return <Chat />
      case 3:
        return <Process />
      case 4:
        return <Box />
      case 5:
        // comissionamento
        return <Comission />
      case 6:
        // Ferramentas
        return <WorkTool />
      case 7:
        // Precificacao
        return <PricingProcess />
      case 8:
        // Treinamento
        return <Training />
      default:
        return <MegaPhone />
    }
  }

  const handlePagination = () => {
    if (
      knowledgeBaseReducer.recents.pagination.currentPage >
      knowledgeBaseReducer.recents.pagination.lastPage
    )
      return null

    return dispatch(
      reducks.resources.knowledgeBase.actions.getRecents({
        fetchMore: true
      })
    )
  }

  const hasPages =
    knowledgeBaseReducer.recents.pagination.currentPage !==
    knowledgeBaseReducer.recents.pagination.lastPage

  return (
    <DefaultLayout>
      <Flex column>
        <Text
          size="lg"
          color="gray"
          variation="dark"
          extraBold
          lineHeight="30px"
        >
          Conteúdos
        </Text>
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            marginTop: 30,
            flexWrap: 'wrap'
          }}
        >
          {!knowledgeBaseReducer.categories.fetching &&
            knowledgeBaseReducer.categories.list.length > 0 && (
              <>
                {knowledgeBaseReducer.categories.list.map((item) => (
                  <Tag
                    onClick={() => applyFilter(item)}
                    size="xs"
                    key={item.id}
                    active={item.id === knowledgeBaseReducer.filters.categoryId}
                    text={item.name}
                    white
                  />
                ))}

                <Button width="160px" onClick={clearFilters}>
                  <Text
                    color="gray"
                    variation="dark"
                    size="xxs"
                    extraBold
                    margin="0px 10px 0px 0px"
                  >
                    Limpar
                  </Text>
                  <MdDelete />
                </Button>
              </>
            )}
        </div>
        {knowledgeBaseReducer.highlights.list.length > 0 && (
          <Text
            size="lg"
            color="gray"
            variation="dark"
            extraBold
            lineHeight="30px"
            margin="34px 0px 22px 0px"
          >
            Destaques
          </Text>
        )}

        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            flexWrap: 'wrap',
            gap: 16
          }}
        >
          {!knowledgeBaseReducer.highlights.fetching &&
            knowledgeBaseReducer.highlights.list.length > 0 &&
            knowledgeBaseReducer.highlights.list.map((item) => (
              <CardHighlight
                key={item.id}
                title={item.title}
                type="comunications"
                classNameTitle={styles.title}
                typeText={item.category.name}
                variation={item.category.code}
                isMarked={item.isFavorite}
                onClick={() => redirectToDetail(item)}
                className={styles.cardPointer}
                onPressMarker={(e) => {
                  e.stopPropagation()

                  dispatch(
                    reducks.resources.knowledgeBase.actions.toggleFavorite({
                      key: 'highlights',
                      item
                    })
                  )
                }}
              />
            ))}
        </div>

        {knowledgeBaseReducer.recents.list.length > 0 && (
          <Text
            size="lg"
            color="gray"
            variation="dark"
            extraBold
            lineHeight="30px"
            margin="48px 0px 30px 0px"
          >
            Conteúdos recentes
          </Text>
        )}

        <div className={styles.row}>
          {!knowledgeBaseReducer.recents.fetching &&
            knowledgeBaseReducer.recents.list.map((item) => (
              <Card key={item.id} className={styles.cardGrid}>
                <div
                  style={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    flex: 1
                  }}
                >
                  <div
                    onClick={() => redirectToDetail(item)}
                    style={{
                      display: 'flex',
                      width: '100%'
                    }}
                  >
                    <div>
                      <Thumbnail
                        gradient
                        type={item.category.code}
                        className={styles.icon}
                      >
                        {renderIconPerType(item.category.code)}
                      </Thumbnail>
                    </div>
                    <Flex column>
                      <Text
                        size="xs"
                        lineHeight="24px"
                        color="gray"
                        variation="dark"
                        bold
                        className={styles.elipsis}
                      >
                        {item.title}
                      </Text>
                      <Text
                        size="xxs"
                        lineHeight="18px"
                        color="gray"
                        variation="light"
                        font="custom"
                        margin="5px 0px 0px 0px"
                      >
                        {item.lastUpdateFormatted}
                      </Text>
                    </Flex>
                  </div>
                  <button
                    type="button"
                    className={styles.saveButton}
                    onClick={() => {
                      dispatch(
                        reducks.resources.knowledgeBase.actions.toggleFavorite({
                          key: 'recents',
                          item
                        })
                      )
                    }}
                  >
                    {!item.isFavorite ? (
                      <MdBookmarkBorder color="#4d4d4d" size={20} />
                    ) : (
                      <MdBookmark color="#4d4d4d" size={20} />
                    )}
                  </button>
                </div>
              </Card>
            ))}
        </div>
        <Flex
          column
          alignItems="center"
          justifyContent="center"
          width="94%"
          padding="0px 0px 20px 0px"
        >
          {(knowledgeBaseReducer.recents.fetching ||
            knowledgeBaseReducer.recents.fetchingMore) && (
            <div style={{ padding: 20 }}>
              <LoadingBounce />
            </div>
          )}
          {hasPages &&
            (!knowledgeBaseReducer.recents.fetching ||
              !knowledgeBaseReducer.recents.fetchingMore) && (
              <button
                type="button"
                onClick={() => handlePagination()}
                className={styles.actionWhite}
              >
                <Text
                  font="custom"
                  color="gray"
                  variation="dark"
                  size="xs"
                  fontWeight="600"
                  lineHeight="20px"
                >
                  ver mais
                </Text>
              </button>
            )}
        </Flex>
        {!knowledgeBaseReducer.recents.fetching &&
          knowledgeBaseReducer.recents.list.length === 0 && (
            <Card className={styles.empty}>
              <Flex column alignItems="center" justifyContent="center" flex="1">
                <BoyNoContent />
                <Text
                  size="md"
                  color="gray"
                  variation="dark"
                  extraBold
                  lineHeight="24px"
                  margin="32px 0px 16px 0px"
                >
                  Conteúdos
                </Text>
                <Text size="xs" color="gray" font="custom" fontWeight="400">
                  Ainda não existe nenhum conteúdo.
                </Text>
              </Flex>
            </Card>
          )}
      </Flex>
    </DefaultLayout>
  )
}

export default Content
